var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-w360 q-fit"},[_c('broad-answer-question',{attrs:{"value":_vm.cosmeticAllergies,"title":"label.cosmeticAllergies"},on:{"input":function($event){return _vm.onFieldChange('cosmeticAllergies', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }